import { Forum as ForumIcon } from "@mui/icons-material";
import { Box, Button, Typography, alpha, useTheme } from "@mui/material";

interface EmptyChannelListProps {
  onCreateMessage: () => void;
}

export const EmptyChannelList = ({ onCreateMessage }: EmptyChannelListProps) => {
  const {
    palette: {
      products: { performance },
    },
  } = useTheme();
  return (
    <Box
      sx={{
        padding: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: alpha(performance.primary, 0.1),
          height: "56px",
          width: "56px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 1,
        }}
      >
        <ForumIcon sx={{ color: performance.primary, fontSize: "32px" }} />
      </Box>
      <Typography variant="h4">No Messages</Typography>
      <Typography variant="body2" sx={{ textAlign: "center" }}>
        Looks like there are no messages yet. Get started by creating and sending one today.
      </Typography>
      <Button onClick={() => onCreateMessage()} fullWidth size={"large"} sx={{ marginTop: 3 }}>
        Create Message
      </Button>
    </Box>
  );
};
